import styled from 'styled-components';

import { Column } from '../../shared/styles';

const NameColumn = styled(Column)`
  width: 30%;
`;

const FundNameColumn = styled(Column)`
  width: 60%;
`;

const PositionColumn = styled(Column)`
  width: 30%;
`;

const SectionTitle = styled.div`
  margin: 48px 0 8px;
  font-size: 19px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-transform: uppercase;
`;

export {
  FundNameColumn,
  NameColumn,
  PositionColumn,
  SectionTitle,
};
